const merge = (pIn, pTo) => {
  Object.keys(pIn).forEach((key) => {
    pTo[key] = pIn[key];
  });
  return pTo;
};

const initGA = () => {
  if (window.ga) {
    window.ga('create', 'UA-27184289-5', {});
  }
};

const addContentBlockListener = (player) => {
  const open = XMLHttpRequest.prototype.open;

  XMLHttpRequest.prototype.open = function () {
    this.addEventListener('readystatechange', (e) => {
      if (
        e.target &&
        e.target['readyState'] === 4 &&
        (e.target['status'] === 451 || e.target['status'] === 401)
      ) {
        // Get the raw header string
        const headers = e.target.getAllResponseHeaders();
        const arr = headers.trim().split(/[\r\n]+/);

        let info = {
          status: e.target['status'],
          limit: null,
          delay: null,
          reason: null,
          cdn_id: null,
          subscription_id: null,
          content_model: null,
          ccb: null,
        };

        arr.forEach(function (line) {
          let parts = line.split(': ');
          let header = parts.shift().toLowerCase();
          let value = parts.join(': ');

          // HEADERS
          // X-Status-Code: 451
          // Retry-After: <delay-seconds>
          // X-CCC-Reason: <reason tag>
          // X-CDN-ID: <MGG CDN ID>
          // X-Connection-Limit: <X>
          // X-Bundle: <bundle tag>

          // RESPONSE FROM CCI
          //{"status":451,"limit":1,"delay":60,"reason":"account","ccb": "sport",}
          switch (header) {
            case 'retry-after':
              info.delay = parseInt(value);
              break;
            case 'x-ccc-reason':
              info.reason = value;
              break;
            case 'x-connection-limit':
              info.limit = parseInt(value);
              break;
            case 'x-bundle':
              info.ccb = value;
              break;
            case 'x-cdn-id':
              info.cdn_id = parseInt(value);
              break;
            case 'x-subscription-id':
              info.subscription_id = parseInt(value);
              break;
            case 'x-content-model':
              info.content_model = value;
              break;
          }
        });
        player.emit('contentBlocked', info);
      }
    });
    open.call(this, ...arguments);
  };
};

const checkContentIsBlocked = (player, src, callback = () => {}) => {
  if (src.search(/\/\/.*\.vcdn\.biz/) === -1) return callback(null);
  const cciUrl = src.replace(/\/\/.*\.vcdn\.biz/, '//cci.vcdn.biz');
  const loader = player.config.getDefaultLoader();

  loader.load(
    cciUrl,
    (data) => {
      try {
        callback(JSON.parse(data));
      } catch {
        callback(null);
      }
    },
    () => {
      callback(null);
    },
    false
  );
};

const checkVolume = (player, options) => {
  const newOpts = { ...options };
  if ('defaultVolume' in newOpts) {
    player.set('volume', Number(newOpts.defaultVolume));
    delete options.defaultVolume;
  }

  if ('defaultMuted' in newOpts) {
    if (Number(options.defaultMuted) === 1) {
      player.set('muted', true);
    }
    delete newOpts.defaultMuted;
  }
  return newOpts;
};

const replaceProtocol = (url) => {
  let result;
  if (typeof url === 'string') {
    result = url.replace(/https?:/, '');
  } else {
    result = url.toString();
  }
  return result;
};

const checkIsIframe = (player) => {
  if (window.self === window.top) {
    return 0;
  }

  let target = window;
  let count = 0;
  let nesting = `${player.config.href}|`;
  const nestingArr = [];

  while (target !== window.top && count < 10) {
    count++;
    target = target.parent;
  }

  if (count > 0 && 'ancestorOrigins' in window.location) {
    for (let i = 0; i < window.location.ancestorOrigins.length; i++) {
      nestingArr.push(window.location.ancestorOrigins.item(i));
    }
    nestingArr.reverse();
    nestingArr.forEach((url) => {
      nesting += `${url}->`;
    });

    nesting = nesting.substr(0, nesting.length - 2);
  }

  window.setTimeout(() => {
    player.emit('ga:customEvent', [
      `deepTrack_${count}`,
      nestingArr.length ? nesting : nesting.substr(0, nesting.length - 1),
      player.config.deviceOS,
    ]);
  }, 500);

  return count;
};

export const dispatchEtUiEvent = (data, player) => {
  const event = {
    text: data.text || '',
    code: data.code || '',
    type: data.type || '',
  };

  player.emit('skin:uiClick', event);
};

const createKibanaData = (data, player) => {
  if (!player) {
    // eslint-disable-next-line no-console
    console.trace(
      'Call createKibanaData without player argument',
      data,
      player
    );
  }
  const kibanaData = clearKibanaData(merge(player.config, data));
  kibanaData.position = player.get('position');

  if (data.vastData) {
    const [ad] = data.vastData.ad;
    const [adtitle] = data.vastData.adtitle;
    kibanaData.ad = ad;
    kibanaData.adtitle = adtitle;
  }

  return clearKibanaData(kibanaData);
};

const clearKibanaData = (data) => {
  const blackList = [
    'kibana',
    'links',
    'comscore',
    'vastData',
    'container',
    'adContainer',
    'vastData',
    'flash',
    'localization',
    'playerOptions',
    'gemius',
    'loadExternalLocalization',
    'singleVideoInstance',
    'xmlURL',
    'videoContainer',
    'showCloseButton',
    'skin',
  ];

  blackList.forEach((item) => {
    delete data[item];
  });

  Object.keys(data).forEach((key) => {
    if (
      typeof data[key] === 'function' ||
      Array.isArray(data[key]) ||
      data[key] === null ||
      Number.isNaN(data[key])
    ) {
      delete data[key];
    }
  });
  return data;
};

const getUserId = (url) => {
  let result = '';
  if (url && url.indexOf('%user_id%') === -1) {
    url = url.replace(/.+start\/(\w|\d)*\//, '');
    if (url) {
      const slashIndex = url.indexOf('/');
      if (slashIndex > 0) {
        result = url.substring(0, slashIndex);
      }
    }
  }
  return result;
};

const checkStreamIsValid = (stream) => 'src' in stream && 'video_id' in stream;

const initializeVideos = (videos) => {
  let promise;
  for (let i = 0, l = videos.length; i < l; ++i) {
    videos[i].style.display = 'inline-block';
    promise = videos[i].play();
    if (promise && typeof promise.catch === 'function') {
      promise.catch(() => {});
    }
  }
};

let volumeBeforeMuted = 60;
const toggleMutedOnVideos = (videos, mutedState, player) => {
  for (let i = 0, l = videos.length; i < l; ++i) {
    videos[i].muted = mutedState;
    if (!mutedState) {
      videos[i].volume = volumeBeforeMuted / 100;
    }
  }

  if (player) {
    if (mutedState) {
      volumeBeforeMuted = player.get('volume') || 60;
    }

    // MHP-1379: player.set('muted, ... напрямую влияет на куку, в дальнейшем нет
    // возможности понять это пользователь мьютил или нет
    // 'player:silentMode' => true не дает менять куку "muted"
    player.set('player:silentMode', true);
    player.set('muted', mutedState);
    player.set('player:silentMode', false);
    player.set('ad:vendor:muted', mutedState);
    if (!mutedState) {
      player.set('volume', volumeBeforeMuted);
      player.set('ad:vendor:volume', volumeBeforeMuted);
    }
  }
};

const subscribeOnIntersectionObserver = (player) =>
  new Promise((resolve) => {
    let inited = false;
    player.registerProperty('sizeInfo', null, true);
    if (!window.IntersectionObserver) {
      resolve();
    }

    const values = [];

    for (let i = 0; i <= 100; ++i) {
      values.push(i === 0 ? 0 : i / 100);
    }

    const property = {
      target: window.top,
      rootMargin: '0px',
      threshold: values,
    };

    const observer = new window.IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        player.set('sizeInfo', entry);
      });
      if (!inited) {
        inited = true;
        resolve();
      }
    }, property);

    observer.observe(player.config.container);
  });

const processDeepTrack = (player) => {
  player.registerProperty('deepTrackInfo', '', true);

  if (!window.location.ancestorOrigins) {
    return;
  }

  const { ancestorOrigins } = window.location;

  let nestingString = player.config.href;
  const nestingArray = [];

  for (let i = 0, l = ancestorOrigins.length; i < l; i++) {
    nestingArray.unshift(ancestorOrigins.item(i));
  }

  nestingArray.forEach((url, index, { length }) => {
    if (index === 0) {
      nestingString += `|${url}`;
    } else {
      nestingString += index < length - 1 ? `${url}->` : url;
    }
  });

  player.set('deepTrackInfo', nestingString);
};

const addAdditionalPlayerOptions = (
  defaultOptions,
  stream,
  storage,
  player
) => {
  const newOptions = {
    ...defaultOptions,
  };

  if (
    stream &&
    !('startSeconds' in newOptions) &&
    'play_start_time' in stream
  ) {
    newOptions.startSeconds = stream.play_start_time;
  }

  if (stream && storage) {
    const targetId = stream['root_video_id'] || stream['video_id'] || 0;
    const savedAudio = storage.getAudioByVideoId(targetId);
    if (savedAudio) {
      newOptions.defaultAudioTrack = savedAudio;
      player.set('objectAudioId', savedAudio);
    } else {
      player.set('objectAudioId', null);
    }
  }

  if (stream && (player.config.audioTag || player.config.audioDRMTag)) {
    const forsedAudio = stream.audio_tracks.find(
      (audio) => audio.lang_tag === player.config.audioTag
    );
    const forsedAudioAlt = stream.audio_tracks.find(
      (audio) => audio.lang_tag === player.config.audioDRMTag
    );
    if (forsedAudio || forsedAudioAlt)
      newOptions.defaultAudioTrack = forsedAudio?.id || forsedAudioAlt?.id;
  }

  return newOptions;
};

const polyfills = () => {
  Number.isNaN =
    Number.isNaN || ((value) => typeof value === 'number' && isNaN(value));
};

const decorateGetStream =
  (player, getStreamFunc) =>
  (...data) => {
    let timeout = typeof data[data.length - 1] === 'number' ? data.pop() : 0;
    let callback = data.pop();

    //MHP-1874: Логика показа лоудера при переходе object - перебивка - postroll
    if (timeout > 0) player.emit('streamFetchSilent', true);
    let getStreamDone = false;
    let streamFetchFired = false;

    setTimeout(() => {
      player.emit('streamFetchSilent', false);

      if (!getStreamDone) {
        player.emit('streamFetch', data);
        streamFetchFired = true;
      }
    }, timeout);

    getStreamFunc.apply(undefined, [
      ...data,
      (...args) => {
        getStreamDone = true;
        if (streamFetchFired) player.emit('streamComplete', data);
        callback(...args);
      },
    ]);
  };

const checkPlayerContainerDimension = (config, container) => {
  config.screenWidth = container.clientWidth;
  config.screenHeight = container.clientHeight;
};

const modifyStreamForRequiredSubs = (stream) => {
  const { audio_tracks: audioTracks, subtitles } = stream;
  if (!audioTracks || !subtitles) return stream;

  const tracksWithRequired = audioTracks.filter((at) => at.require_subtitles);
  let tracksToRemove = [];
  if (subtitles.length === 0) {
    tracksToRemove = tracksWithRequired.map((t) => t.id);
  } else if (subtitles.length === 1) {
    const [s] = subtitles;
    tracksWithRequired.forEach((track) => {
      if (s.lang === track.lang) {
        tracksToRemove.push(track.id);
      }
    });
  }

  const newStream = { ...stream };
  if (tracksToRemove.length > 0) {
    newStream.audio_tracks = audioTracks.filter(
      (at) => !tracksToRemove.includes(at.id)
    );
  }
  return newStream;
};

/*
MHP-1793
MHP-1831
MHP-2099
Для корректной работы плеера нужно размечать video и iframe внутри плеера атрибутом ignore
иначе CMP логика на сайте может нам сильно навредить. Учитывая что нужные нам елементы создаются
в разных местах я не придумал ничего лучше чем глобальный слушатель мутаций внутри player container

*/
const addDataAdtConsentIgnoreAttribute = (targets) => {
  targets.forEach((target) => {
    if (target) target.setAttribute('data-adl-consent', 'ignore');
  });
};

export default {
  merge,
  initGA,
  checkVolume,
  replaceProtocol,
  checkIsIframe,
  dispatchEtUiEvent,
  createKibanaData,
  getUserId,
  checkStreamIsValid,
  initializeVideos,
  toggleMutedOnVideos,
  subscribeOnIntersectionObserver,
  processDeepTrack,
  addAdditionalPlayerOptions,
  addContentBlockListener,
  checkContentIsBlocked,
  polyfills,
  decorateGetStream,
  modifyStreamForRequiredSubs,
  checkPlayerContainerDimension,
  addDataAdtConsentIgnoreAttribute,
};
